import { call, put } from 'redux-saga/effects'

import history from '../../../history'
import {
  CategoryDetailInterface,
  CreateCategoryInputInterface
} from '../../../interfaces/category'
import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { createCategorySucceed, requestFailure } from '../actions'

export function* createCategorySaga(
  categoryApi: {
    createCategory: (...args: any[]) => any
  },
  {
    payload: categoryDetail
  }: {
    payload: CreateCategoryInputInterface
  }
) {
  try {
    const { data }: { data: CategoryDetailInterface } = yield call(
      categoryApi.createCategory,
      categoryDetail
    )
    yield put(createCategorySucceed(data))
    yield call(history.push, `/category/${data.categoryId}/edit`)
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
